import React from 'react'
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
} from 'react-share'
import PropTypes from 'prop-types'

import { pick } from '@styled-system/props'

import get from 'lodash/get'

import { DATA_LAYERS } from 'Constants/DataLayers'
import { WEB_URL } from 'Constants/Ids'
import { BLOG_POST, ROOT } from 'Constants/Paths'

import { addDataLayer } from 'Services/gtm'

import { Container } from './styles'

function ShareBlock({ post, absolute, ...rest }) {
  const title = get(post, 'title', 'StartupCraft Blog Post')
  const shareUrl = `${WEB_URL}${BLOG_POST(post?.permalink ?? ROOT)}`

  return (
    <Container {...pick(rest)} absolute={absolute}>
      <LinkedinShareButton
        title={title}
        url={shareUrl}
        windowHeight={600}
        windowWidth={750}
        onClick={() => addDataLayer(DATA_LAYERS.blog.shareLinkedIn)}
      >
        <LinkedinIcon round size={40} />
      </LinkedinShareButton>

      <TwitterShareButton
        title={title}
        url={shareUrl}
        onClick={() => addDataLayer(DATA_LAYERS.blog.shareTwitter)}
      >
        <TwitterIcon round size={40} />
      </TwitterShareButton>

      <FacebookShareButton
        quote={title}
        url={shareUrl}
        onClick={() => addDataLayer(DATA_LAYERS.blog.shareFacebook)}
      >
        <FacebookIcon round size={40} />
      </FacebookShareButton>
    </Container>
  )
}

ShareBlock.defaultProps = {
  absolute: false,
  post: null,
}

ShareBlock.propTypes = {
  absolute: PropTypes.bool,
  post: PropTypes.object,
}

export default ShareBlock
